export enum PlusCountingUnitEnum {
  HOURS = "HOURS",
  DAYS = "DAYS",
}
